import React from 'react';
import PropTypes from 'prop-types';
import Button from "semantic-ui-react/dist/es/elements/Button/Button.js";
export var Component = function Component(_ref) {
  var children = _ref.children,
      href = _ref.href,
      isFluid = _ref.isFluid,
      isPositionedRight = _ref.isPositionedRight,
      onClick = _ref.onClick,
      willOpenInNewTab = _ref.willOpenInNewTab;
  return React.createElement(Button, {
    as: href && 'a',
    basic: true,
    floated: isPositionedRight ? 'right' : 'left',
    fluid: isFluid,
    href: href,
    onClick: onClick,
    target: willOpenInNewTab ? '_blank' : '_self',
    type: "button"
  }, children);
};
Component.displayName = 'Link';
Component.defaultProps = {
  href: null,
  isFluid: false,
  isPositionedRight: false,
  onClick: Function.prototype,
  willOpenInNewTab: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  isFluid: PropTypes.bool,
  isPositionedRight: PropTypes.bool,
  onClick: PropTypes.func,
  willOpenInNewTab: PropTypes.bool
} : {};